import { normalizeUnternehmensform, UNTERNEHMENSFORM_MIETWAGEN } from './transportWording';

/**
 * Fahrpreismodus des Mandanten: Taxameter (Endpreis am Fahrtende) oder
 * Festpreis vorab (verbindlicher Serverpreis vor der Bestellung).
 *
 * Abgeleitet aus `appSettings/general.unternehmensform`, solange
 * `preismodell` nicht ausdrücklich auf 'taxameter' steht:
 *   mietwagen → festpreis_vorab,  taxi → taxameter.
 * Für Mietwagen ist der Festpreis Standard, aber keine Pflicht
 * (`preismodell: 'taxameter'` = Wegstreckenzähler, Ablauf wie bisher).
 * `preismodell: null` heißt „abgeleitet".
 *
 * Spiegelt nextcab_mobile/functions/src/shared/preismodell.ts und
 * lib/models/app_settings.dart — alle drei synchron halten.
 * Siehe nextcab_mobile/docs/general/mietwagen_festpreis_modus_konzept.md §4.
 */

export const PREISMODELL_TAXAMETER = 'taxameter';
export const PREISMODELL_FESTPREIS_VORAB = 'festpreis_vorab';

export const resolvePreismodell = (general) => {
  const data = general || {};
  if (normalizeUnternehmensform(data.unternehmensform) !== UNTERNEHMENSFORM_MIETWAGEN) {
    return PREISMODELL_TAXAMETER;
  }
  return data.preismodell === PREISMODELL_TAXAMETER ? PREISMODELL_TAXAMETER : PREISMODELL_FESTPREIS_VORAB;
};

export const isFestpreisVorab = (general) => resolvePreismodell(general) === PREISMODELL_FESTPREIS_VORAB;

/** Arten von Zusatzgebühren (Katalog im Portal, Knöpfe in der Fahrer-App). */
export const ZUSATZ_ARTEN = [
  { value: 'pauschal', label: 'Pauschal' },
  { value: 'pro_stueck', label: 'Je Stück' },
  { value: 'wartezeit', label: 'Wartezeit je Minute' },
  { value: 'grossraum', label: 'Großraumzuschlag (Betrag aus dem Tarif)' },
];

/** Vorschlag für einen neuen Katalog (Konzept §6.2). Nur Großraum ist aktiv. */
export const ZUSATZ_VORSCHLAEGE = [
  { id: 'grossraum', label: 'Großraumzuschlag', art: 'grossraum', eur: 0, freiMinuten: 0, aktiv: true },
  { id: 'gepaeck', label: 'Zusätzliches Gepäckstück', art: 'pro_stueck', eur: 2, freiMinuten: 0, aktiv: false },
  { id: 'sperrgepaeck', label: 'Sperrgepäck (Fahrrad, Kinderwagen …)', art: 'pro_stueck', eur: 5, freiMinuten: 0, aktiv: false },
  { id: 'tier', label: 'Tier', art: 'pauschal', eur: 3, freiMinuten: 0, aktiv: false },
  { id: 'wartezeit', label: 'Wartezeit am Abholort', art: 'wartezeit', eur: 0.5, freiMinuten: 5, aktiv: false },
];

/** Stabile id aus der Bezeichnung (eigene Einträge), eindeutig gegenüber `existing`. */
export const zusatzIdFromLabel = (label, existing = []) => {
  const base = String(label || '')
    .toLowerCase()
    .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 30) || 'gebuehr';
  const taken = new Set(existing);
  if (!taken.has(base)) return base;
  let i = 2;
  while (taken.has(`${base}_${i}`)) i += 1;
  return `${base}_${i}`;
};
